import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type StoreBaseReturn } from '@shared/api';

interface UseRejectCreditLimitStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  rejectCreditLimit: (applicationId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useRejectCreditLimitStore = create<UseRejectCreditLimitStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  rejectCreditLimit: async (applicationId, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.rejectCreditLimit(applicationId, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
